import React, { memo } from 'react'

import NavHeader from '../../../components/navHeader/NavHeader'

const NavHeaderWrapper = (props) => {
  return <NavHeader {...props} />
}

export default memo(NavHeaderWrapper)
